import React from "react";
import { NumberCont } from "../utils";

function Impact({ title, background, purpleText }) {
  return (
    <div className={`mt-24 py-4 ${background && `bg-light-200 bg-opacity-30`}`}>
      {title && (
        <h1 className="font-semibold font-josefin text-6xl text-mix-400 text-center pt-20 pb-20 px-4">
          Our Impact
        </h1>
      )}
      <div className="pb-24">
        <div className="flex flex-col sm:flex-row justify-between sm:justify-evenly items-center">
          <NumberCont title={130} subTitle="Volunteers" purpleText />
          <NumberCont title={7} subTitle="Active Campaigns" purpleText />
          <NumberCont
            title={3000}
            subTitle="Lives Impacted"
            sign="+"
            purpleText
          />
        </div>
      </div>
    </div>
  );
}

export default Impact;
